import { useLang } from "../LanguageContext";
import { Chapter, Reveal } from "./Chapter";

const Why = () => {
  const { t } = useLang();
  const w = t.why;

  return (
    <Chapter id="perche" num={w.num} kicker={w.kicker} title={w.title} dark>
      <div
        className="pointer-events-none absolute inset-0"
        style={{ background: "radial-gradient(50% 40% at 85% 10%, rgba(136,155,135,0.12), transparent 70%)" }}
      />
      <div className="relative grid gap-px overflow-hidden border border-linen/10 bg-linen/10 sm:grid-cols-2">
        {w.items.map((item, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <div
              data-testid={`why-pillar-${i + 1}`}
              className="group flex h-full flex-col bg-forest p-8 transition-colors duration-500 hover:bg-olive sm:p-12"
            >
              <span className="font-mono text-[11px] tracking-[0.3em] text-gold">0{i + 1}</span>
              <h3 className="mt-6 font-serif text-2xl font-light leading-snug tracking-tight text-linen sm:text-3xl">
                {item.title}
              </h3>
              <p className="mt-5 text-sm font-light leading-relaxed text-linen/70 sm:text-base">{item.text}</p>
              <span className="mt-8 h-px w-10 bg-terra transition-[width] duration-500 group-hover:w-24" />
            </div>
          </Reveal>
        ))}
      </div>
    </Chapter>
  );
};

export default Why;
